import type { FC, ReactNode } from 'react'

import type { WhiteLabel } from '@skytech/types'
import { twJoin } from 'tailwind-merge'

import './styles.scss'

export const ErrorMessage: FC<{ children: ReactNode; className?: string }> = ({
  children,
  className,
}) => {
  // todo: replace with the org from url when ready
  const whiteLabel = localStorage.getItem('org') as WhiteLabel

  return <div className={twJoin('ui-error', whiteLabel, className)}>{children}</div>
}
